<template>
  <div class="animated fadeIn" style="overflow-y:hidden">
    <div class="row">
      <div class="col">
        <span>Claim report for email: {{emailAddress}} and HOYA account number: {{accountNumber}}</span>
      </div>
    </div>
    <br/>
    <div class="row">
      <div class="col">
        <button type="button" class="btn btn-primary" @click="refreshReport()">
          Refresh report
        </button>
      </div>
      <div class="col">
        <button type="button" class="btn btn-primary" onclick="printJS('printableWindow', 'html')">
          Print report
        </button>
      </div>
    </div>
    <br/>
    <div style="border:1px solid black;padding: 20px">
      <div id="printableWindow">
        <h2 align="center">MALAYSIAN HOYA LENS SDN. BHD.</h2>

        <p style="text-decoration: underline;">E-SURPRISE REWARD</p>

        <div class="row" style="margin-bottom: 10px">
          <div class="col">
            Date of Collection:
          </div>
          <div class="col" style="border-bottom: 1px solid black;">
          </div>
          <div class="col">
            <!-- <p>*Preferred Mode of Payment:</p>
            <p>GIRO:</p>
            <div style="border: 1px solid black;">
            </div> -->
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px">
          <div class="col">
            Hoya A/C No:
          </div>
          <div class="col" style="border-bottom: 1px solid black;">
            {{capAccountNumber}}
          </div>
          <div class="col">
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px">
          <div class="col">
            Customer:
          </div>
          <div class="col" style="border-bottom: 1px solid black;">
            {{capName}}
          </div>
          <div class="col">
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px">
          <div class="col">
            Hoya Sales Rep Name:
          </div>
          <div class="col" style="border-bottom: 1px solid black;">
          </div>
          <div class="col">
          </div>
        </div>

        <b-row>
          <b-col style="border: 1px solid black;" sm="2">
            Vouchers
          </b-col>
          <b-col style="border: 1px solid black;" sm="2">
            QTY (PCS)
          </b-col>
          <b-col style="border: 1px solid black;" sm="2">
            TOTAL AMT (RM)
          </b-col>
          <b-col style="border: 1px solid black;">
            Remark
          </b-col>
        </b-row>

        <b-row v-for="claims in groupedClaims" v:bind:data="claims" v-bind:key="claims.moneyType">
          <b-col style="border: 1px solid black;" sm="2">
            RM{{claims.moneyType}}
          </b-col>
          <b-col style="border: 1px solid black;" sm="2">
            {{claims.pieces}}
          </b-col>
          <b-col style="border: 1px solid black;" sm="2">
            {{claims.totalAmount}}
          </b-col>
          <b-col style="border: 1px solid black;">
          </b-col>
        </b-row>

        <b-row>
          <b-col style="margin-bottom: 10px;border: 1px solid black;" sm="2">
            TOTAL
          </b-col>
          <b-col style="margin-bottom: 10px;border: 1px solid black;" sm="2">
            {{totalPieces}}
          </b-col>
          <b-col style="margin-bottom: 10px;border: 1px solid black;" sm="2">
            {{totalAmount}}
          </b-col>
          <b-col style="margin-bottom: 10px;border: 1px solid black;">
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="3">
            Acknowledged by:
          </b-col>
          <b-col style="border-bottom: 1px solid black;" sm="3">
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            (Customer/ECP)
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            Name:
          </b-col>
          <b-col sm="3" style="border-bottom: 1px solid black;">
          </b-col>
          <b-col sm="3">
            Company Stamp:
          </b-col>
          <b-col style="border-bottom: 1px solid black;">
          </b-col>
        </b-row>

        <br/><br/>
        <div style="border-bottom: 1px dashed black;"></div>
        <br/>

        <h4 align="center">GIRO Bank Info</h4>

        <b-row style="margin-bottom: 10px;">
          <b-col>
            Payee Bank:
          </b-col>
          <b-col style="border-bottom: 1px solid black;">
            {{capBankName}}
          </b-col>
          <b-col>
            Bank Account Name:
          </b-col>
          <b-col style="border-bottom: 1px solid black;">
            {{capBankAccountName}}
          </b-col>
        </b-row>

        <b-row style="margin-bottom: 10px;">
          <b-col>
            Payee Bank Branch:
          </b-col>
          <b-col style="border-bottom: 1px solid black;">
          </b-col>
          <b-col>
            Bank Account No:
          </b-col>
          <b-col style="border-bottom: 1px solid black;">
            {{capBankAccountNumber}}
          </b-col>
        </b-row>

        <b-row style="margin-bottom: 10px;">
          <b-col>
          </b-col>
          <b-col>
          </b-col>
          <b-col>
            Payee Email Address:
          </b-col>
          <b-col style="border-bottom: 1px solid black;">
            {{capEmail}}
          </b-col>
        </b-row>

      </div>
    </div>
  </div>
</template>
<script>
var printjs = require('print-js')
export default {
  props: ['name', 'email', 'accountNumber', 'bankName', 'bankAccountName', 'bankAccountNumber'],
  data () {
    return {
      searchObject: {
        email: '',
        accountNumber: ''
      }
    }
  },
  created: function () {
    this.$store.dispatch('ucrmod/fetchUserClaims', { email: this.email })
  },
  methods: {
    print: function (param1, param2) {
      console.log('Print: ' + printjs)
      printjs.printJS(param1, param2)
    },
    refreshReport: function (params) {
      this.$store.dispatch('ucrmod/fetchUserClaims', { email: this.email })
    }
  },
  computed: {
    emailAddress: function () {
      return this.email
    },
    groupedClaims: function () {
      return this.$store.state.ucrmod.groupedByMoneyTypeClaims
    },
    totalPieces: function () {
      return this.$store.state.ucrmod.totalPieces
    },
    totalAmount: function () {
      return this.$store.state.ucrmod.totalAmount
    },
    capName: function () {
      return this.name
    },
    capEmail: function () {
      return this.email
    },
    capAccountNumber: function () {
      return this.accountNumber
    },
    capBankName: function () {
      return this.bankName
    },
    capBankAccountName: function () {
      return this.bankAccountName
    },
    capBankAccountNumber: function () {
      return this.bankAccountNumber
    }
  },
  name: 'UserClaimReport'
}
</script>



// WEBPACK FOOTER //
// src/views/UserClaimReport.vue